import { CardDetailsType } from '@islandsstofa/react'

export const countTagOccurence = (list: CardDetailsType[], tag: string) => {
  let counter = 0
  for (let i = 0; i < list.length; i++) {
    if (list[i].tags?.includes(tag)) {
      counter++
    }
  }
  return counter
}

export const OPPORTUNITY_TYPES = [
  'Styrkur',
  'Innkaup',
  'Markaðstækifæri',
  'Viðburður',
  'Atvinnutækifæri',
]


export const CAPITAL_TYPES = ['Styrkur', 'Lán', 'Hlutafé', 'Innkaup']
